import React, { useEffect, useRef, useState } from 'react';
import queryString from 'query-string';
import OftadehLayout from '../../components/OftadehLayout/OftadehLayout';
import { Button, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import swal from '@sweetalert/with-react';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import ListIcon from '@material-ui/icons/List';
import DeleteIcon from '@material-ui/icons/Delete';
import axiosInstance from '../../constants/AxiosInstance';
import { API_URL, getDefName } from '../../constants';
import { getCustomInfo, getProductTypeList } from '../../constants/PromiseHttp';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    color: '#3f51b5',
  },
  my3: {
    margin: '1.3rem 0',
  },
  mb0: {
    marginBottom: 0,
  },
  mRight: {
    marginRight: '.85rem',
  },
  p1: {
    padding: '.85rem',
  },
}));

const CustomDetailPage = (props) => {
  const query = queryString.parse(props.location.search);
  const type = query.type ? query.type : 'new';

  const editor = useRef(null);
  const [custom, setCustom] = useState({});
  const [types, setTypes] = useState([]);

  const { history } = props;
  const classes = useStyles();

  const [uploadFile, setUploadFile] = useState([]);
  const childRef = useRef(null);
  const imgKey = 'files';

  const handleChangeData = (value, field) => {
    custom[field] = value;
    setCustom({ ...custom });
  };

  useEffect(() => {
    if (type === 'edit' && query.id) {
      getData();
    } else {
      setCustom([]);
    }
  }, []);

  const getData = () => {
    getCustomInfo(query.id).then((result) => {
      setCustom(result);
      if (childRef.current) {
        childRef.current.getSignedUrl(result[imgKey]);
      }
    });
    getProductTypeList().then((result) => {
      setTypes(result);
    });
  };

  const addCustom = () => {
    let param = {};

    if (type === 'new') {
      axiosInstance.post(`${API_URL}/custom/`, param).then(async (response) => {
        if (response.status === 200) {
          if (childRef.current && response.data.value.id) {
            await Promise.all([childRef.current.fileUpload(uploadFile, response.data.value.id, 'custom', `${API_URL}/custom/`)]);
            swal('Registered.', {
              icon: 'success',
            });
            goList();
          } else {
            swal('Registered.', {
              icon: 'success',
            });
            goList();
          }
        }
      });
    }
  };

  const deleteCustom = () => {
    swal({
      title: 'Are you sure you want to delete?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.delete(`${API_URL}/custom/${query.id}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
          if (response.status === 200) {
            swal('It is deleted.', {
              icon: 'success',
            });
            goList();
          }
        });
      } else {
      }
    });
  };

  const goList = () => {
    history.push('/pages/custom/');
  };

  const getProdCategoryName = (id) => {
    const obj = types.find((obj) => obj.id === id);
    return obj ? obj[getDefName()] : '';
  };

  const getTourCategoryName = (lang, type) => {
    //관광지:0, 문화시설:1, 음식점:2
    if (lang === 'kr' || lang === 'ko') {
      switch (type) {
        case '12':
          return '관광지'; //0
        case '14':
          return '문화시설'; //1
        case '39':
          return '음식점'; //2
        default:
          return '관광지'; //0
      }
    } else {
      switch (type) {
        case '76':
          return 'Tourist Attraction'; //0
        case '78':
          return 'Cultural facilities'; //1
        case '82':
          return 'Restaurant'; //2
        default:
          return 'Tourist Attraction'; //0
      }
    }
  };

  const TourList = () => {
    return (
      <>
        {custom?.tour?.map((dateItem, index) => {
          const date = Object.keys(dateItem)[0];
          const items = dateItem[date];

          return (
            <div key={index}>
              <h3>{date}</h3>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {items.map((item, idx) => (
                  <li key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <img
                      src={item.img || `/images/noImg.png`}
                      alt={item.title}
                      style={{ width: '64px', height: '64px', marginRight: '16px' }}
                    />
                    <div>
                      <p>
                        <strong>{item.title}</strong>
                      </p>
                      <p>{item.type === 1 ? getProdCategoryName(item.category) : getTourCategoryName(item.lang, item.category)}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <OftadehLayout>
      <Grid container className={classes.my3} alignItems="center">
        <Grid item className={classes.mRight} style={{ fontWeight: 'bold' }}>
          <Typography variant="h5" component="h1" style={{ fontWeight: 'bold' }}>
            Custom Detail
          </Typography>
        </Grid>
      </Grid>

      <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} mb={12}>
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                Basic Info
              </Typography>
            </Grid>
            <Grid item xs={4} mb={6}>
              <div className={classes.title}>Language</div>
              <Typography variant="body1">{(custom && custom.languageId) || ''}</Typography>
            </Grid>
            <Grid item xs={4} mb={6}>
              <div className={classes.title}>Name</div>
              <Typography variant="body1">{(custom && custom.userName) || ''}</Typography>
            </Grid>
            <Grid item xs={4} mb={6}>
              <div className={classes.title}>Email</div>
              <Typography variant="body1">{(custom && custom.userId) || ''}</Typography>
            </Grid>
          </Grid>
          <Divider style={{ marginTop: '10px' }} />
          <Grid container spacing={3} style={{ marginTop: '10px' }}>
            <Grid item xs={12} mb={12}>
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                Schedule
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.title}>Title</div>
              <Typography variant="body1">{(custom && custom.title) || ''}</Typography>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.title}>Duration</div>
              <Typography variant="body1">
                {(custom && custom.startDate) || '-'} ~ {(custom && custom.endDate) || '-'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {custom && <TourList />}
            </Grid>
          </Grid>
        </CardContent>
        <CardActions style={{ marginLeft: '16px', marginRight: '16px' }}>
          <Grid container item xs={12} md={12} spacing={3}>
            <Grid item>
              <Button
                variant="contained"
                style={{ backgroundColor: green[700], color: '#ffffff', marginRight: '10px' }}
                size="medium"
                onClick={goList}
                startIcon={<ListIcon />}
              >
                List
              </Button>
              {type !== 'new' ? (
                <Button variant="contained" color="secondary" size="medium" onClick={deleteCustom} startIcon={<DeleteIcon />}>
                  Delete
                </Button>
              ) : null}
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </OftadehLayout>
  );
};

export default CustomDetailPage;
